// DO NOT REMOVE, REQUIRED FOR CYPRESS INTEGRATION TESTS TO SUPPORT FETCH
import 'react-app-polyfill/ie11';
import 'webrtc-adapter';
import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';
import {ProviderWrapper} from './components/ProviderWrapper';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <ProviderWrapper>
    <App />
  </ProviderWrapper>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
